/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'

/** Same image as the headbar user menu. */
export const USER_AVATAR_IMAGE_SRC = '/src/assets/images/avatar.png'

export type UiUserAvatarSize = 'sm' | 'md' | 'lg' | 'xl'

const sizeClasses: Record<UiUserAvatarSize, string> = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24',
}

interface UiUserAvatarProps {
    size?: UiUserAvatarSize
    className?: string
    alt?: string
}

const UiUserAvatar: React.FC<UiUserAvatarProps> = ({
    size = 'sm',
    className,
    alt = 'User avatar',
}) => (
    <img
        src={USER_AVATAR_IMAGE_SRC}
        alt={alt}
        className={clsx('UiUserAvatar rounded-full object-cover', sizeClasses[size], className)}
    />
)

export default UiUserAvatar
